import React from 'react';
import cc from 'classcat';
import HTMLReactParser from 'html-react-parser';

import styles from './styles.module.scss';

interface Props {
  title?: string | null;
  subtitle?: string | null;
  address?: string | null;
  intro?: string | null;
  image?: { url: string; title?: string | null } | null;
}

const MenorahHero = ({ title, subtitle, address, intro, image }: Props) => (
  <div className={styles.hero}>
    <div className="container">
      <div className={cc({ [styles.inner]: true, [styles.innerNoImage]: !image })}>
        <div className={styles.content}>
          {title && <h1 className={styles.title}>{title}</h1>}
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          {address && <p className={styles.address}>{address}</p>}
          {intro && (
            <div className={styles.intro}>
              {HTMLReactParser(intro)}
            </div>
          )}
        </div>
        {image && (
          <div className={styles.imageContainer}>
            <img
              src={image.url}
              alt={image.title || ''}
              className={styles.heroImage}
            />
          </div>
        )}
      </div>
    </div>
    {/* Signature background swoop */}
    <div className={styles.heroBackground}>
      <svg className={styles.svgOverlay} preserveAspectRatio="none" viewBox="0 0 732 542" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 541.5V0H732C688.5 20.6667 572.607 97.6433 429.5 205.5C293.5 308 264.5 336 174.5 470.5C129.961 537.061 87 537 63.5 541.5H0Z" fill="inherit"/>
      </svg>
      <div className={styles.whiteUnderlay} />
    </div>
  </div>
);

export default MenorahHero;
